import { Component } from 'react';
import styles from './number-input.component.module.scss'

interface NumberInputProps {
    value?: number;
    onChange: (value: number) => void
}

interface NumberInputState {
    localValue: string;
}

export class NumberInputComponent extends Component<NumberInputProps, NumberInputState> {
    private debounceTimer: any = null;

    constructor(props: NumberInputProps) {
        super(props);
        this.state = { localValue: props.value != null ? String(props.value) : '' };
    }

    componentDidUpdate(prevProps: NumberInputProps) {
        // Sync from parent only when not actively typing
        if (prevProps.value !== this.props.value && !this.debounceTimer) {
            this.setState({ localValue: this.props.value != null ? String(this.props.value) : '' });
        }
    }

    componentWillUnmount() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
    }

    updateValue(newValue: string) {
        this.setState({ localValue: newValue });
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.debounceTimer = null;
            const value = newValue.length > 0 ? Number(newValue) : undefined;
            this.props.onChange(value);
        }, 50);
    }

    render() {
        return <div className={styles['number-input']}>
            <input
                type="number"
                aria-label="Numeric value input"
                value={this.state.localValue}
                onChange={(e) => this.updateValue(e.target.value)}
            />
        </div>
    }
}
